import { render } from "./orderCard.vue?vue&type=template&id=84d63a0e"
import script from "./orderCard.vue?vue&type=script&lang=js"
export * from "./orderCard.vue?vue&type=script&lang=js"

import "./orderCard.vue?vue&type=style&index=0&id=84d63a0e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__